import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawConsentsListResponse } from '../types/consent';
import type { RequestOptions } from '../types/common';

export function createConsentApi(http: Http) {
  return {
    async list(options?: RequestOptions): Promise<RawConsentsListResponse> {
      const res = await http.get<RawConsentsListResponse>(endpoints.consent.base, {
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
